import * as ActionTypes from './action.js';

const reducerMap = {
    // 改变path
    [ActionTypes.PATH_CHANGE]: (state, payload) => {
        return Object.assign({}, state, {
            path: payload,
        });
    },
    // edit param
    [ActionTypes.EDIT_PARAM_STATUS]: (state, payload) => {
        return Object.assign({}, state, payload);
    },
    // 获取用户信息
    [ActionTypes.GET_USER_SUCCESS]: (state, payload) => {
        return Object.assign({}, state, {
            fetchStatus: false,
            ...payload.data,
            product: payload.product,
        });
    },
    // 修改学科信息
    [ActionTypes.MODIFY_SUBJECT_INFO]: (state, payload) => {
        return Object.assign({}, state, {});
    },
    // 退出登陆
    [ActionTypes.EXITLOGIN]: (state, payload) => {
        return Object.assign({}, state, {});
    },
    // 会认生字，会写生字
    [ActionTypes.SET_CATEITEM_INFO]: (state, payload) => {
        const { cateitem_group } = payload;
        return Object.assign({}, state, {
            cateitem_list: cateitem_group
        });
    },
}

export const INITIALIZE_STATE = {
    subject: '0',
    grade_part: '10',
    stem_style: [],
    cateitem_list: []
}
const reducer = (state = INITIALIZE_STATE, action = {}) => {
    const { type, payload } = action;
    const reducer = reducerMap[type];
    if (reducer) {
        return reducer(state, payload);
    } else {
        return state;
    }
};
export default reducer


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_tml/reducer.js